<template>
    <div class="goods">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'goods',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.goods {
}
</style>
